// Full-screen title/splash screen shown over the game on load. It sits inside
// the phone "screen" (so on desktop it stays within the device frame) and is
// dismissed by the Play button, revealing the already-booted game underneath.
export class Intro {
  private readonly element = document.querySelector<HTMLElement>('.js-intro');
  private readonly play = document.querySelector<HTMLButtonElement>('.js-intro-play');

  constructor() {
    this.play?.addEventListener('click', () => this.dismiss());
  }

  private dismiss(): void {
    if (this.element) this.element.hidden = true;
  }
}
